<h1>Copilot in Studio/M365</h1>
<br>Setting up MCP integration in Copilot Studio Agents/M365 Agents work out of the box because it supports OAuth2 secured MCP servers with Dynamic Client Registration.
<img src="/copilot-studio.png" title="Copilot studio" class="big-image" alt="Copilot Studio interface showing MCP integration setup">
